import { extraChargesActionTypes } from '../../actions/configurations/extraChargesAction';

const ExtraChargesReducers = (state = {}, action) => {
  switch (action.type) {
  case extraChargesActionTypes.GET_EXTRA_CHARGES.LOADING: {
    const { getChargeLoading } = action;
    return {
      ...state,
      getChargeLoading,
    };
  }

  case extraChargesActionTypes.GET_EXTRA_CHARGES.SUCCESS: {
    const { extraChargesResults } = action;
    return {
      ...state,
      extraChargesResults,
    };
  }

  case extraChargesActionTypes.UPDATE_EXTRA_CHARGES.LOADING: {
    const { updateChargeLoading } = action;
    return {
      ...state,
      updateChargeLoading,
    };
  }

  case extraChargesActionTypes.CREATE_EXTRA_CHARGES.LOADING: {
    const { createChargeLoading } = action;
    return {
      ...state,
      createChargeLoading,
    };
  }

  case extraChargesActionTypes.DELETE_EXTRA_CHARGES.LOADING: {
    const { deleteChargeLoading } = action;
    return {
      ...state,
      deleteChargeLoading,
    };
  }

  default: {
    return state;
  }
  }
};

export default ExtraChargesReducers;
